
import React from 'react'

function ReceivablesDetails(props,) {
const details = props.data
  return (
    <div>
        <br/>
            <Detstatbles title="Description" valaue={details.description}/>
            <Detstatbles title="Amount" valaue={'N'+details.amount}/>
            <Detstatbles title="Received From" valaue={details.receivedFrom}/>
            <Detstatbles title="Received On" valaue={details.receivedOn}/>
            <Detstatbles title="bills" valaue={details.bills}/>
           
        <br/>
    </div>
  )
}

export default ReceivablesDetails




 function Detstatbles({title,valaue}) {
  return (
    <div className='row'>
    <div className='col s12'>
        <span>
            <b>
                {title}: 
            </b>
        </span>
         <span style={{
            marginLeft:"10px"
         }}>
             {valaue}
        </span>
    </div>
</div>
  )
}
